import { useState,useEffect } from "react";
import { Button, Nav, Navbar } from "react-bootstrap"


const Header = ({current_page}: {current_page: string}) => {
  const  [buttonCaption, setButtonCaption] = useState<string>("");

  useEffect(() => {
    const locoenv = localStorage.getItem("locoEnv");
    if (locoenv == null) {
      localStorage.setItem("locoEnv", "prod");
    }
    setButtonCaption(locoenv ? locoenv : "prod")
  }, []) 

  const setApiEnv = () => {
    switch(localStorage.getItem("locoEnv")) {
      case "prod":
        localStorage.setItem("locoEnv", "stg");
        setButtonCaption("stg")
        break;
      case "stg":
        localStorage.setItem("locoEnv", "prod");
        setButtonCaption("prod")
        break;
      default:
        localStorage.setItem("locoEnv", "prod");
        setButtonCaption("prod")
        break;
    }
  }
  return (
    
    <Navbar expand="lg" bg="dark" variant='dark'>
      <Navbar.Brand className="font-weight-bold" href="https://loco-tools-portal.bcw-mt.com/">AggregateStationLogSankey</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
      <Nav className='mr-auto'>
        {current_page === "Home" ? <Nav.Item><Nav.Link href='/Home' className="active">Home</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/Home'>Home</Nav.Link></Nav.Item>}
        {current_page === "AggregatelogsTime" ? <Nav.Item><Nav.Link href='/AggregatelogsTime' className="active">ログ数集計</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/AggregatelogsTime'>ログ数集計</Nav.Link></Nav.Item>}
        {current_page === "PastAndFutureDevice" ? <Nav.Item><Nav.Link href='/PastAndFutureDevice' className="active">過去と未来のデバイス履歴</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/PastAndFutureDevice'>過去と未来のデバイス履歴</Nav.Link></Nav.Item>}
        {current_page === "CommonDevice" ? <Nav.Item><Nav.Link href='/CommonDevice' className="active">２つのビーコン群に接触するデバイス抽出</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/CommonDevice'>２つのビーコン群に接触するデバイス抽出</Nav.Link></Nav.Item>}
      </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Header